import { render, staticRenderFns } from "./GJgrowEventCreateQuestionSettingDetail.vue?vue&type=template&id=67410e1a&scoped=true&"
import script from "./GJgrowEventCreateQuestionSettingDetail.vue?vue&type=script&lang=ts&"
export * from "./GJgrowEventCreateQuestionSettingDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67410e1a",
  null
  
)

export default component.exports